import React from "react";

function Pendidikan() {
  return (
    <div className="lg:pl-10 lg:pb-10 px-10 py-8 animate-fade-in animation-delay-200">
      <h1 className="text-2xl text-center lg:text-left lg:text-3xl font-bold lg:pt-20 pb-3 text-gradient-primary">
        RIWAYAT PENDIDIKAN
      </h1>
      <div className="w-24 h-1 bg-gradient-accent rounded-full mx-auto lg:mx-0 mb-8"></div>
      <ol className="relative border-l border-gray-200">
        <ul className="mb-5 ml-4">
          <div className="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -left-1.5 border border-[#F3F3F3]"></div>
          <time className="mb-1 text-sm font-normal leading-none text-gray-400">
            2016 - 2021
          </time>
          <li className="text-base font-medium">
            Universitas Sriwijaya
          </li>
          <p className="text-sm">Teknik Informatika - Ilmu Komputer</p>
        </ul>

        <ul className="mb-5 ml-4">
          <div className="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -left-1.5 border border-[#F3F3F3]"></div>
          <time className="mb-1 text-sm font-normal leading-none text-gray-400">
            2013 - 2016
          </time>
          <li className="text-base font-medium">
            SMA Muhammadiyah 4 Kota Bengkulu
          </li>
          <p className="text-sm">IPA</p>
        </ul>

        <ul className="mb-5 ml-4">
          <div className="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -left-1.5 border border-[#F3F3F3]"></div>
          <time className="mb-1 text-sm font-normal leading-none text-gray-400">
            2010 - 2013
          </time>
          <li className="text-base font-medium">
            SMP Negeri 9 Kota Jambi
          </li>
        </ul>

        <ul className="mb-5 ml-4">
          <div className="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -left-1.5 border border-[#F3F3F3]"></div>
          <time className="mb-1 text-sm font-normal leading-none text-gray-400">
            2004 - 2010
          </time>
          <li className="text-base font-medium">
            SD Negeri 1 Kota Metro
          </li>
        </ul>
      </ol>
    </div>
  );
}

export default Pendidikan;